/**
 * WHAT THE BETA RECORDS (Phase 13B, spec §58H).
 *
 * Stated plainly, where a tester will actually see it: once while they are
 * setting up their account, and afterwards from the application itself.
 * Nothing here is softened, and nothing is buried.
 */
export function PrivacyNotice({ variant = "page" }: { variant?: "onboarding" | "page" }) {
  return (
    <section className={variant === "onboarding" ? "privacy-notice privacy-notice-inline" : "privacy-notice panel"}>
      <h3>What Berrier Reno records during Early Access</h3>
      <p className="muted workspace-note">
        So the software can be improved, Berrier Reno keeps a limited record of <strong>how it is used</strong> and{" "}
        <strong>when it breaks</strong>:
      </p>
      <ul className="muted">
        <li>when you sign in and which parts of the application you open;</li>
        <li>
          that certain things happened — a project was created, a baseline was created, a report was generated — as
          named events, without their contents;
        </li>
        <li>errors, with the screen and operation they happened in and a sanitized technical message;</li>
        <li>anything you choose to write in Send Feedback.</li>
      </ul>
      <p className="muted workspace-note">
        It does <strong>not</strong> record your screen, your keystrokes, your mouse movement, or the contents of your
        projects: no addresses, no amounts, no vendor names, no receipts, no attachments. An event says that a change
        order was created — never what it was worth.
      </p>
      <p className="muted workspace-note">
        Anything you upload — receipts, invoices, plans, photographs — is stored in your own workspace and is used only
        to run Berrier Reno for you. It is not shared with other accounts and is not used to train anything. The
        original file is always kept as you sent it.
      </p>
      <p className="muted workspace-note">
        Your project data stays in your own database on the Berrier Reno server and is not shared with other accounts unless you share a project.
        Berrier Holdings can see your account, your activity summary, your errors and your feedback — the same things
        listed above. Ask at any time and the record for your account will be deleted.
      </p>
    </section>
  );
}
